import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class CoursesComponent extends Component
{
	@service store;
	@service errorManager;
	
	@tracked isAddingNewCourse = false;
	@tracked newCourseName = "";
	
	@action
	async saveNew(browserEvent)
	{
		browserEvent.preventDefault();

		const newCourse = this.store.createRecord('course',
		{
			name: this.newCourseName,
			EventId: this.args.event,
		});

		try
		{
			await newCourse.save();
			await this.store.findRecord('course', newCourse.id);
		}
		catch (error)
		{
			// Error is displayed by the adapter
			newCourse.rollbackAttributes();
			return;
		}

		this.newCourseName = "";
		this.isAddingNewCourse = false;
	}
	
	
	@action
	cancelNew()
	{
		this.newCourseName = "";
		this.isAddingNewCourse = false;
	}
	
	@action
	async deleteCourse(course)
	{
		var classGroups = await course.classGroups;

		if(classGroups.length > 0)
		{
			this.errorManager.addError("Course is used by a class group. Cannot be deleted.", { clearable: true, type: 'validation' });
			return;
		}
		else
		{
			course.deleteRecord();
			try
			{
				await course.save();
			}
			catch (error)
			{
				// Error is displayed by the adapter
				course.rollbackAttributes();
			}
		}
	}
}